import { useState, useEffect } from 'react';

interface GeoRestrictionProps {
  children: React.ReactNode;
}

export default function GeoRestriction({ children }: GeoRestrictionProps) {
  const [status, setStatus] = useState<'loading' | 'allowed' | 'blocked'>('loading');

  useEffect(() => {
    fetch('https://ipapi.co/json/')
      .then((res) => res.json())
      .then((data) => {
        if (data.country_code === 'US') {
          setStatus('allowed');
        } else {
          setStatus('blocked');
        }
      })
      .catch(() => {
        // If the check fails, allow access by default
        setStatus('allowed');
      });
  }, []);

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#faf9f7]">
        <div className="text-center">
          <div className="w-10 h-10 border-2 border-[#8B7355] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-[#8B7355] font-light tracking-widest text-sm uppercase" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Loading...
          </p>
        </div>
      </div>
    );
  }

  if (status === 'blocked') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#faf9f7] px-6">
        <div className="text-center max-w-md">
          <div className="mb-8">
            <h1
              className="text-4xl font-light text-[#3d3530] tracking-widest mb-2"
              style={{ fontFamily: 'Cormorant Garamond, serif' }}
            >
              Bodhira
            </h1>
            <div className="w-12 h-px bg-[#8B7355] mx-auto" />
          </div>

          <div className="mb-8">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
              <i className="ri-earth-line text-[#8B7355]" style={{ fontSize: '3rem' }} />
            </div>
            <h2
              className="text-2xl font-light text-[#3d3530] mb-4 tracking-wide"
              style={{ fontFamily: 'Cormorant Garamond, serif' }}
            >
              Currently Available in the US Only
            </h2>
            <p className="text-[#7a6e65] text-sm leading-relaxed font-light">
              We're sorry — Bodhira is currently only available to visitors in the United States.
              We hope to expand to more regions soon.
            </p>
          </div>

          <div className="border-t border-[#e8e0d8] pt-6">
            <p className="text-[#9e9189] text-xs tracking-widest uppercase">
              Thank you for your understanding
            </p>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
